module.exports = __webpack_public_path__ + "static/media/web1.20300184.jpg";